import { customerSummaryConstants } from ".././constants";

// Moved to @rista/core/data/constants (shared.ts — byte-identical in both apps) —
// re-exported so this file's importers are unchanged.
export { DISCOUNT_CLASS_TYPES } from "@rista/core/data/constants";

// Moved to @rista/core/data/constants (shared.ts — identical in both apps).
export { DISCOUNT_TYPES } from "@rista/core/data/constants";

export { DISCOUNT_MODES } from "@rista/core/data/constants";

// Moved to @rista/core/utils/constants (same value in every copy).
export { PICKUP } from "@rista/core/utils/constants";
export { DELIVERY } from "@rista/core/data/constants"; // moved to core 2026-09-15 (my-orders actions)
export { INSTORE } from "@rista/core/data/constants"; // moved to core 2026-09-15 (my-orders actions)

export const DISABLED_PAYMENTS = [
  "hdfcsmarthub",
  "mobikwik",
  "paytmqr",
  "mintoak",
];

export const VIEW_TYPE = 'VIEW_TYPE';
export const VIEW_TYPE_MOBILE = 'VIEW_TYPE_MOBILE';
export const viewTypes = {
  grid: 'grid',
  list: 'list',
  simple: 'simple',
};
export { CHANNEL_TYPE_POS } from "@rista/core/data/constants"; // moved to core 2026-09-15 (order card)

export const SELECTION_MODES = {
  DELIVERY: "Delivery",
  PICKUP: "Pickup",
  DINE_IN: "Dine In",
  TAKEAWAY: "Takeaway",
};

export { DOTPE_SOURCE_TYPES } from "@rista/core/data/constants"; // moved to core 2026-09-15 (order card; identical in both apps)

export { DAAS_CONSTANTS } from "@rista/core/data/constants"; // moved to core 2026-09-15 (rider row; identical in both apps)

export const PRINTER_TYPES_KEYS = {
  USB_PRINTER : 'usb-printer',
  LOCAL_PRINTER : 'local-printer',
  defaultPrinter: "defaultPrinter",
}

export const DEFAULT_PRINTER_OBJ = {
  mid: "defaultPrinter",
  label: "Default Printer",
};

export const PRINTER_TYPES = {
  USB : "USB",
  LOCAL : "LOCAL",
  ble: "ble",
  network: "network"
}

export const ITEM_TAGS: any = {
  veg: "rista-new-sprite veg-icon",
  nveg: "rista-new-sprite non-veg-icon",
  egg: "rista-new-sprite eggetarian-icon",
  default: "rista-new-sprite eggetarian-icon",
};

export const DATE_TIME_FORMATS = {
  doMMMM: "Do MMMM",
  doMMM: "Do MMM",
  hhmmA: "hh:mm A",
  hmmA: "h:mm A",
  hhmm: "hh:mm",
  HHmm: "HH:mm",
  YYYMMDD: "YYYY-MM-DD",
  dddd: "dddd",
  MMMD: "MMM D",
  MMMDYYYY: "MMM D, YYYY",
  YYYYMMDDLT: "YYYY-MM-DD | LT",
  DDMMYYY: "DD MM YYYY",
  DDMMYYY1: "DD-MM-YYYY",
  DDMMMYYYY: "DD-MMM-YYYY",
  X:"x",
  DDMMMhh_MM_A: "DD MMM hh:mm A",
  YYYY_MM_DD_hh_mm_ss: 'YYYY-MM-DD | hh:mm:ss',
};

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

// Moved to @rista/core/data/constants (identical in both apps) — re-exported so this
// file's importers are unchanged.
export { METHODS } from "@rista/core/data/constants";

export const APP_SOURCE = "appSource";

export const APP_SOURCE_TYPES = {
  POS_MOBILE: "pos_mobile",
  POS_DESKTOP: "pos_desktop",
};

export const REDIRECT_PAGE_IDS = {
  DISCOUNT_DEALS: "discount-deals",
  CHECKOUT_CONTAINER: "checkout-container",
  CUSTOMER_INFO: "customer-info",
  ITEM_STATUS: "item-status",
  DETAILS_VIEW: "details-view",
};

// Moved to @rista/core/data/constants — re-exported so this file's importers are unchanged.
export { ORDER_SOURCE } from "@rista/core/data/constants";
export const NW_EVENTS = {
  ADVANCE_ORDER_EVENT: "ADVANCE_ORDER_EVENT"
};

// Moved to @rista/core/utils/constants (this app's superset; mobile declared it in
// utils/constants). Re-exported so this file's importers are unchanged. Not used here.
export { ACTION_STATES } from "@rista/core/utils/constants";

export const AGGREGATORS_DETAILS: any = {
  zomato: {
    name: "Zomato",
    iconClass: "web-my-order-icons zomato-logo",
  },
  swiggy: {
    name: "Swiggy",
    iconClass: "web-my-order-icons swiggy-logo",
  },
  magicpin: {
    name: "magicpin",
    iconClass: "web-my-order-icons magicpin-logo",
  },
  dotpe: {
    name: "Dotpe",
    iconClass: "web-my-order-icons dotpe-logo",
  },
};

export const NOTIFICATIONS_TYPE: any = {
  newCustomerComplaint: "CUSTOMER_COMPLAINT",
  feedbackReceived: "NOTIFY_ON_FEEDBACK_SUBMIT",
  aggregatorItemStockStatus: "AGGREGATOR_ITEM_STOCK_STATUS",
  menuSyncUpdate: "MENU_SYNC_UPDATE",
  inventoryActivity: "INVENTORY_ACTIVITY_NOTIFICATION",
  newOfflineOrder: "OFFLINE_ORDER_STATUS",
  customerApproval: "CUSTOMER_AUTHENTICATION_APPROVAL",
  messageFromBusiness: "USER_BROADCAST_MESSAGE",
  orderApprovalRequest: "ORDER_APPROVAL",
  orderApprovalStatus: "ORDER_APPROVAL_STATUS",
  operationalAlert: "OPERATIONAL_ALERT",
  lowSalesAlert: "LOW_SALE_ALERT",
  auditReminderAlert: "AUDIT_REMINDER_ALERT",
  auditEscalationAlert: "AUDIT_ESCALATION_ALERT",
  aggregatorOrderRating: "AGGREGATOR_ORDER_RATING",
  aggregatorOutletStatus: "AGGREGATOR_OUTLET_STATUS",
  stockStatus: "INVENTORY_STOCK_STATUS",
  lowStock: "INVENTORY_LOW_STOCK",
  soldOutItemsUpdate: "SOLDOUT_ITEMS_UPDATE",
  approvePurchaseOrderRequest: "PURCHASE_ORDER_APPROVAL_REQUEST",
  purchaseOrderApprovalStatus: "PURCHASE_ORDER_APPROVAL_STATUS",
  approveNonChargeableOrder: "APPROVE_NON_CHARGEABLE_SALE"
};

export const APPROVAL_NOTIFICATION_TYPES = [
  NOTIFICATIONS_TYPE.orderApprovalRequest,
  NOTIFICATIONS_TYPE.approvePurchaseOrderRequest,
  NOTIFICATIONS_TYPE.approveNonChargeableOrder,
];

export const NOTIFICATIONS_TEXT: any = {
  customerComplaint:
    "A feedback / complain has been received for a Zomato order",
};

export const NOTIFICATIONS_EVENTTYPES: any = {
  "Feedback Received": "NOTIFY_ON_FEEDBACK_SUBMIT",
  "New Customer Complaint": "CUSTOMER_COMPLAINT",
  "Aggregator item stock status": "AGGREGATOR_ITEM_STOCK_STATUS",
  "Menu Sync Update": "MENU_SYNC_UPDATE",
  "Inventory Activity": "INVENTORY_ACTIVITY_NOTIFICATION",
  "New Offline Order": "OFFLINE_ORDER_STATUS",
  "Customer Approval": "CUSTOMER_AUTHENTICATION_APPROVAL",
  "Message from Business": "USER_BROADCAST_MESSAGE",
  "Order Approval Request": "ORDER_APPROVAL",
  "Order Approval Status": "ORDER_APPROVAL_STATUS",
  "Operational Alert": "OPERATIONAL_ALERT",
  "Low Sales Alert": "LOW_SALE_ALERT",
  "Audit Reminder Alert": "AUDIT_REMINDER_ALERT",
  "Audit Escalation Alert": "AUDIT_ESCALATION_ALERT",
  "Aggregator order rating": "AGGREGATOR_ORDER_RATING",
  "Aggregator outlet status": "AGGREGATOR_OUTLET_STATUS",
  "Stock Status": "INVENTORY_STOCK_STATUS",
  "Low Stock": "INVENTORY_LOW_STOCK",
  "Sold Out Items Update": "SOLDOUT_ITEMS_UPDATE",
  "Approve Purchase Order Request": "PURCHASE_ORDER_APPROVAL_REQUEST",
  "Purchase Order Approval Status": "PURCHASE_ORDER_APPROVAL_STATUS",
  "Purchase Order": "PURCHASE_ORDER"
};

// Moved to @rista/core/data/constants (index.desktop.ts — mobile's has only 5 of these 11
// keys, so the two are NOT merged) — re-exported so this file's importers are unchanged.
export { NOTIFICATION_VARIABLES } from "@rista/core/data/constants";

export const GET_CTA_TITLE: any = {
  CUSTOMER_COMPLAINT: "View",
  AGGREGATOR_ITEM_STOCK_STATUS: "View Item Stock",
  AGGREGATOR_OUTLET_STATUS: "View  Listing Status",
  MENU_SYNC_UPDATE: "View Online Listings",
  INVENTORY_ACTIVITY_NOTIFICATION: "Go to Inventory",
  OFFLINE_ORDER_STATUS: "View Order",
  CUSTOMER_AUTHENTICATION_APPROVAL: "Accept",
};
export const OOS_CHIP_CLASS = 'font-bold px-4 py-[3px] text-black/50 text-10 border border-[0.5px] rounded-[4px]';

export const NOT_AVAILABLE = 'Not Available'

export { BACK_ORDER_MESSAGE } from "@rista/core/data/constants";
export const NC_SALE_REQUEST_MESSAGE = 'Non chargeable requires manager approval'
// local - indexed DB, server - online server db
export const SALE_VERSION_TYPES = {
  SERVER: "server",
  LOCAL: "local",
}

export const QualityButtonData = [
  {
   text : 'Accept',
   textColor: '#FFFFFF',
   bgColor : '#397EF5',
   variantVal: '',
   borderColor: '',
   textSize: 'text-[16px]',
   borderRadius: '8px'
  }
]

export const MarkReadyOutlier = [
  {
    text : 'View Order',
    textColor: '#397EF5',
    bgColor : '#ffff',
    variantVal: '',
    borderColor: '#397EF5',
    textSize: 'text-[16px]',
    borderRadius: '8px'
  },
  {
    text : 'Mark Ready',
    textColor: '#FFFFFF',
    bgColor : '#397EF5',
    variantVal: '',
    borderColor: '',
    textSize: 'text-[16px]',
    borderRadius: '8px'
   }
]

export const CommonModalButton = [
  {
   text : 'Ok',
   textColor: '#FFFFFF',
   bgColor : '#397EF5',
   variantVal: '',
   borderColor: '',
   textSize: 'text-[16px]',
   borderRadius: '8px'
  }
]

export { TABLE_RESERVATION_ERROR } from "@rista/core/data/constants"; // moved to core (R7-F5: the phone's transfers read it too)
export const DOCUMENT_TITLE_TYPE = {
  LOGIN: "Login - Rista Pos",
  MY_ORDER: "My Order - Rista Pos",
  NEW_ORDER: "New Order - Rista Pos",
  TABLE_VIEW: "Table View - Rista Pos",
  RESERVATIONS: "Reservations - Rista Pos",
  DEFAULT: "Rista Pos",
}
export { INSUFFICIENT_STOCK } from "@rista/core/data/constants";
export { ITEM_SOLD_OUT } from "@rista/core/data/constants";
export { ITEM_OOS } from "@rista/core/data/constants"; // moved to core 2026-09-29 (My Orders v2's back-order sheet)
export { ASSIGN_NOTE } from "@rista/core/data/constants"; // moved to core 2026-09-15 (rider row)
export { SELF_DELIVERY } from "@rista/core/data/constants"; // moved to core 2026-09-15 (rider row)

export const ORDER_CHANNELS = {
  ONLINE: "Online",
  POS: "POS",
  RENEWAL: "Renewal",
} as const;

export { SALE_TRANSACTION_TYPES } from "@rista/core/data/constants"; // moved to core with the feature gate

/**
 * Events sent to native app
 */
// Moved to @rista/core/data/constants (index.desktop.ts — web-only; mobile defines no such
// constant) — re-exported so this file's importers are unchanged.
export { REACT_NATIVE_APP_EVENTS } from "@rista/core/data/constants";

export const REACT_NATIVE_APP_EVENT_KEYS = {
  setPrinter: "setPrinter",
  setDefaultPrinter: "setDefaultPrinter",
  deleteBlePrinter: "deleteBlePrinter",
  deleteUsbPrinter: "deleteUsbPrinter",
  getPreviousConnectionDetails: "getPreviousConnectionDetails",
  scanBluetoothDevices: "scanBluetoothDevices",
  scanUsbDevices: "scanUsbDevices",
} as const;

// Moved to @rista/core/data/constants (index.desktop.ts — both are web-only; mobile
// defines neither) — re-exported so this file's importers are unchanged.
export { NW_APP_EVENT_KEYS, NW_APP_EVENT_ACTIONS } from "@rista/core/data/constants";

export { SWIGGY_CONTACT_KEY, ZOMATO_CONTACT_KEY, OWNLY_CONTACT_KEY } from "@rista/core/data/constants"; // moved to core 2026-09-16 (reject flow sheet)

export const TABLE_FILTER_MAP = {
  Free: "Free",
  Occupied: "Occupied",
  printed: "printed",
  tableName: "tableName",
  occupancy: "occupancy",
  allTable: "allTables",
  others: "others",
  resourceGroupId: "resourceGroupId",
  vacant: "vacant",
  open: "open",
  billPrinted: "billPrinted",
  reservation: "reservation"
}

export const RESERVED_TABLE = 'reserved'

export const TABLE_FILTER_CHIP_DATA = [
  {
    id: TABLE_FILTER_MAP.vacant,
    bgColor: "#C5E1A5",
    filter: {
      type: TABLE_FILTER_MAP.occupancy,
      value: TABLE_FILTER_MAP.Free
    },
    label: "Vacant",
    isPermittedOffline: true
  },
  {
    id: TABLE_FILTER_MAP.open,
    bgColor: "#B3E5FC",
    filter: {
      type: TABLE_FILTER_MAP.occupancy,
      value: TABLE_FILTER_MAP.Occupied
    },
    label: "Open",
    isPermittedOffline: true
  },
  {
    id: TABLE_FILTER_MAP.billPrinted,
    bgColor: "#FFECB3",
    filter: {
      type: TABLE_FILTER_MAP.occupancy,
      value: TABLE_FILTER_MAP.printed
    },
    label: "Bill Printed",
    isPermittedOffline: true
  },
  {
    id: RESERVED_TABLE,
    bgColor: "#D9C8FF",
    filter: {
      type: RESERVED_TABLE,
      value: RESERVED_TABLE
    },
    label: "Reserved",
    isPermittedOffline: false
  }
] as const;

export const ALL_TABLE = "All Tables";

export const RETURN_PAYMENT_ERROR = "Return payment cannot exceed the balance amount"

/**
 * The four label-sticker-settings constants that lived here — `PRINT_STAGES_TYPE_DATA_LIST`,
 * `BARCODE_DELIMETERS_TYPE_DATA_LIST`, `ITEM_LABEL_GROUP_FIELDS_CONFIG_LIST` and
 * `ITEM_LABEL_SETTING_FIELDS_CONFIG_LIST` — moved to `@rista/core/itemLabelSettings/registry`
 * and are NOT re-exported: nothing outside that flow ever imported them.
 *
 * The two config lists became `LABEL_SETTING_FIELDS` / `LABEL_GROUP_FIELDS`, where each entry
 * now also declares its option SOURCE and row KIND. That is what let the screen's four parallel
 * `switch (fieldId)` statements go: a field is described in one place instead of five.
 * The two data lists became `PRINT_STAGE_CHOICES` / `BARCODE_DELIMITER_CHOICES`.
 */

export const ITEM_TYPES = {
  VARIANT: "Variant",
  ITEM: "Item",
  GROUP: "Group",
};

export const ITEM_TYPE = {
  ITEM: 'item',
  CATEGORY: 'category',
  OPTIONSET: 'optionset',
} as const;

// Moved to @rista/core (shared.ts — byte-identical in both apps, values diffed before collapsing) — re-exported so this file's importers are unchanged.
export { CATEGORY_TYPE } from "@rista/core/data/constants";

export type ItemType = typeof ITEM_TYPE[keyof typeof ITEM_TYPE];

export const ITEM_TYPE_CONFIG: Record<ItemType, { keys: string[]; useInfoPath: boolean }> = {
  [ITEM_TYPE.ITEM]:      { keys: ['longName', 'shortName', 'description'], useInfoPath: true },
  [ITEM_TYPE.CATEGORY]:  { keys: ['name', 'description'],                  useInfoPath: false },
  [ITEM_TYPE.OPTIONSET]: { keys: ['name', 'label', 'description'],         useInfoPath: false },
};

// Moved to @rista/core/data/constants — `blockCustomerChangeIfLocked` raises it on BOTH
// platforms now, so the sentence cannot live in one app.
export { CUSTOMER_EDIT_INFO_FOR_LOYALTY } from "@rista/core/data/constants";

// Moved to @rista/core/data/constants (shared.ts) so apps/mobile stops comparing against a bare
// 'Printed' literal — re-exported so this file's importers are unchanged. Not imported as well:
// nothing in this file's own body reads it.
export { ITEM_LABEL_PRINTING_STATUSES } from "@rista/core/data/constants";

/**
 * Minimum versions of the NW app required for certain features
 */
// Moved to @rista/core/data/constants (index.desktop.ts — both are web-only; mobile defines
// neither) — re-exported so this file's importers are unchanged.
export { MIN_NW_APP_VERSION_SUPPORTED, NW_APP_LATEST_STABLE_VERSION } from "@rista/core/data/constants";

export const EXTERNAL_PAYMENT_PROVIDERS = {
  gyftr: {
    mid: "gyftr",
  },
  eazydiner: {
    mid: "eazydiner",
  },
  razorpayedc: {
    mid: "razorpayedc",
  }
} as const;

export const RESERVATION_STATUS_TYPES = {
  Tentative: "Tentative",
  Confirmed: "Confirmed",
  Cancelled: "Cancelled"
}

// Moved to @rista/core/data/constants (shared.ts). The _C2/_C3 lists followed
// EXTERNAL_LOYALTY_PARTNERS into core on 2026-08-26, and the whole group moved from
// index.desktop.ts to shared.ts on 2026-09-04 so packages/core/loyalty could stay
// platform-neutral. LOYALTY_PROGRAM_TYPE went with them. Nothing in this file's body
// references any of these names, so a plain re-export is correct — restore the extra `import`
// alongside it the moment one is used here (ledger rule 5 / hazard 30).
export {
  EXTERNAL_LOYALTY_PARTNERS,
  EXTERNAL_LOYALTY_PROVIDER_METAIDS,
  EXTERNAL_LOYALTY_PARTNERS_C1,
  EXTERNAL_LOYALTY_PARTNERS_C2,
  EXTERNAL_LOYALTY_PARTNERS_C3,
  LOYALTY_PROGRAM_TYPE,
} from "@rista/core/data/constants";

export const QWIKCILVER_PAYMENT_TYPES = {
  WALLET: "wallet",
  GIFTCARD: "giftcard",
}

// paymentdefs object received from businessData present in businessStore
export type PAYMENT_DEF_DATA_TYPE = {
  isCash: boolean;                          //field passed whether the roundoff should be enabled or not
  enable: boolean;
  disableCashDrawerToggleField: number;
  mode: string;                             //payment mode
  type: string;
}

export const BILL_ROUNDING_MODE = {
  ROUND_UP: "Round Up",
  ROUND_DOWN: "Round Down",
  DO_NOT_ROUND: "Do Not Round",
}

export const HEALTH_SERVICE_CHECK_INTERVAL = 10000;

export const SOFT_LOCK_ACTIVE = 1;
export const LOGIN_ATTEMPT_INITIAL_COUNT = -1;

interface HeaderConfig {
  [key: string]: {
    id: string;
    label: string;
  };
};

export const HEADER_CONFIG: HeaderConfig = {
    favourites: {
      id: "favourites",
      label: "Favourites",
    },
    feedback: {
      id: "feedback",
      label: "Feedback",
    },
    profile: {
      id: "profile",
      label: "Profile",
    },
    redeemed_coupons: {
      id: customerSummaryConstants?.REDEEMED_COUPONS,
      label: customerSummaryConstants?.REDEEMED_COUPONS_HEADER,
    },
    loyalty: {
      id: "loyalty",
      label: "Loyalty",
    },
  }

// Moved to @rista/core/data/constants (index.desktop.ts — web-only).
export { SALE_SOURCE_TYPES } from "@rista/core/data/constants";
// Moved to @rista/core/data/constants (shared.ts — `@rista/core/printing`'s toastSkip, 2026-10-08).
export { DEFAULT_PRINTER_MSG } from "@rista/core/data/constants";

export const PASSWORD_VALIDATION_PATTERNS = [
  { key: "minLength", label: "Minimum 8 characters", pattern: /.{8,}/ },
  { key: "hasUpperCase", label: "One uppercase letter (A–Z)", pattern: /[A-Z]/ },
  { key: "hasLowerCase", label: "One lowercase letter (a–z)", pattern: /[a-z]/ },
  { key: "hasNumber", label: "One number (0–9)", pattern: /\d/ },
  { key: "hasSpecialChar", label: "One allowed special characters: !, @, #, $, %, ^, &, *_", pattern: /[!@#$%^&*]/ },
] as const;

export const CREDENTIAL_TYPE = {
  PASSWORD: "PASSWORD",
  PIN: "PIN",
} as const;

export const MAX_PIN_LENGTH = 10;
export const MIN_PIN_LENGTH = 4;

export const CLARITY_ACCOUNT_UUIDS = [  //TODO add accounts for which clarity needs to be enabled
  "6d02a3fb-8ccf-4347-b7d7-60d65f8134ad",
  process.env.REACT_APP_SUBWAY_ACCOUNT_UUID,
] as const;

export const NOTIFICATION_TITLES = {
  ONLINE_ORDER: "New Online Order",
  INSTORE_ORDER: "New In Store Order",
  TABLE_ORDER: "Table Order Update",
} as const;

// Moved to @rista/core/data/constants — re-exported so this file's importers are unchanged.
export { REST_SALE_BACK_ITEMS_NOT_PROCESSED, LAST_NETWORK_ERROR } from "@rista/core/data/constants";

// Moved to @rista/core/data/constants.
//   shared.ts        -> LOGIN_TYPES + the LoginTypes type (byte-identical in both apps; `as const`
//                       is carried over because the type is derived from it and IS used)
//   index.desktop.ts -> LIST_TYPES (web-only)
//   shared.ts        -> IS_SUGGESTIVE_SELLING_V2_ENABLED — SHARED as of the Suggestive Selling
//                       convergence, since both platforms now run the same flow. It still reads
//                       localStorage at module-eval, exactly as it did here.
export { LIST_TYPES, IS_SUGGESTIVE_SELLING_V2_ENABLED, LOGIN_TYPES } from "@rista/core/data/constants";
export type { LoginTypes } from "@rista/core/data/constants";
